import {Alert, Button, Col, Container, Modal, ModalBody, ModalHeader, Row, Table} from "react-bootstrap";
import {PendingRequestDetails} from "../../modal/pending-request-details";
import RejectRequest from "./reject-request";
import AddVapOption from "./add-vap-option";
import {useState} from "react";
import {ActivationRequestItem} from "../../modal/activation-request-item";
import AddedItemsList from "./added-items-list";
import useCallBackend from "../../hooks/use-call-backend";
import {SaveActivationRequest, SaveActivationResponse} from "../../modal/save-activation-objects";
import Loading from "../../common/loading";
import Error from "../../common/error";

const RequestDetails:React.FC<{requestId:number | null, pendingReqDetails: PendingRequestDetails, resetView: () => void}> = (props) => {
    const {isLoading, error, invokeBackend} = useCallBackend();
    const reqDetails = props.pendingReqDetails.requestDetails;
    const fspNumbers = props.pendingReqDetails.fspNumbers;
    const [addedProducts, setAddedProducts] = useState<ActivationRequestItem[]>([]);
    const [requestUpdated, setRequestUpdated] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const handleAddRequestItem = (requestItem:ActivationRequestItem) => {
        const foundItem = addedProducts.find(item => item.product.id === requestItem.product.id);
        if(foundItem){
            // eslint-disable-next-line no-restricted-globals
            const override = confirm("Product already selected!\nDo you want to update the product?");
            if(override){
                setAddedProducts([...addedProducts.filter(item => item.product.id !== requestItem.product.id), requestItem]);
            }
        }else{
            setAddedProducts([...addedProducts, requestItem]);
        }
    }

    const handleRemoveItem = (itemToRemove: ActivationRequestItem) => {
        setAddedProducts([...addedProducts.filter(item => item !== itemToRemove)]);
    }

    const handleSubmitResponse = (response: SaveActivationResponse) => {
        if(response.done) {
            setRequestUpdated(true);
        }
    }

    const handleSubmitRequest = () => {
        if(props.requestId === null){
            return;
        }

        setShowModal(true);

        const saveRequest: SaveActivationRequest = {
            requestId: props.requestId,
            products: addedProducts.map(productItem => ({
                productId: productItem.product.id,
                activateAll: productItem.activateAll,
                optionIds: productItem.options.map(optionItem => optionItem.id)
            }))
        }

        invokeBackend({url: "/api/vapActivation/saveRequest", method: "POST", body: JSON.stringify(saveRequest)}, handleSubmitResponse);
    }

    const handleCloseModal = () => {
        if(requestUpdated) {
            props.resetView();
        }
    }

    const processingModal = (
        <Modal show={showModal} onHide={handleCloseModal} backdrop="static" animation={false}>
            {!isLoading && (error || requestUpdated) && <ModalHeader closeButton>Response:</ModalHeader>}
            <ModalBody>
                {isLoading && <Loading />}
                {error && <Error message={error} />}
                {requestUpdated && <Alert variant="success">Done...</Alert>}
            </ModalBody>
        </Modal>
    );

    return (
        <Container className="border border-secondary rounded bg-light">
            <Row>
                <Col>
                    <strong>Requester:</strong>
                    <div>{reqDetails.firstName} {reqDetails.lastName}</div>
                </Col>
                <Col>
                    <strong>Dealer:</strong>
                    <div>{reqDetails.dealerName} ({reqDetails.thirdPartyId})</div>
                </Col>
                <Col>
                    <strong>Reg:</strong>
                    <div>{reqDetails.registrationNumber}</div>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col>
                    <strong>FSP:</strong>
                    <div>
                        {fspNumbers.map(items => items.fspNumber).join(", ")}
                    </div>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col>
                    <strong>Address:</strong>
                    <div>{reqDetails.address1}, {reqDetails.address2}, {reqDetails.address3}, {reqDetails.addressCode}</div>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col>
                    <strong>Request:</strong>
                    <div>{reqDetails.comment}</div>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col>
                    <AddVapOption addItemHandler={handleAddRequestItem} />
                    <RejectRequest requestId={props.requestId} resetView={props.resetView} />
                </Col>
            </Row>
            <Row className="mt-3">
                <Col>
                    {addedProducts.length > 0 && <AddedItemsList itemList={addedProducts} removeItemHandler={handleRemoveItem} />}
                    {addedProducts.length > 0 && <Button variant="primary" className="mb-3" onClick={handleSubmitRequest}>Submit</Button>}
                    {processingModal}
                </Col>
            </Row>
        </Container>
    );
}

export default RequestDetails;